import { render } from "./ExpiredContracts.vue?vue&type=template&id=12fb4881&scoped=true"
import script from "./ExpiredContracts.vue?vue&type=script&lang=js"
export * from "./ExpiredContracts.vue?vue&type=script&lang=js"

import "./ExpiredContracts.vue?vue&type=style&index=0&id=12fb4881&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fb4881"]])

export default __exports__